// Components
import ImageZoom from '../components/imageZoom';

// Templates
import productGallery from '../templates/product-gallery-slider.hbs';
import contentNav from '../templates/product-content-nav.hbs';
import contentSections from '../templates/product-content-sections.hbs';

export default class ProductDetail {
    constructor() {
        if (Electro.DEBUG) {
            console.log('ProductDetail.constructor()');
        }

        this.state = {
            activeSKU: 0,
            post: {},
            slickSettings: {
                gallery: {
                    rows: 0,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                },
            },
        };

        this.render();
        this.initListeners();
    }

    initListeners() {
        $('#sku-select-nav').on('change', (e) => {
            e.preventDefault();
            const $el = $(e.currentTarget);
            const sku = $el.find('option:selected').val();

            if (Electro.DEBUG) {
                console.info(`select SKU: ${sku}`);
            }

            this.state.activeSKU = sku;
            $('html, body').animate({ scrollTop: $('header').outerHeight() }, 400);
            this.reInit();
        });
    }

    async fetchPost() {
        const slug = $('body').attr('id');
        // const postID = $('body').attr('data-post');
        try {
            const response = await fetch(`/wp-json/wp/v2/cp_product?slug=${slug}&acf_format=standard`, { credentials: 'same-origin' });
            const json = await response.json();
            Object.assign(this.state.post, json[0]);
            if (Electro.DEBUG) {
                console.log(this.state.post);
            }
        } catch (error) {
            console.error('Failed to get products.', error);
        }
    }

    initProductGallery() {
        $('.slick-slider.slider--gallery').slick(this.state.slickSettings.gallery);

        // Navigate by label
        $('.slider__nav .nav__item').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.slider__nav').find('.nav__item').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.slideshow-wrapper').find('.slick-slider').slick('slickGoTo', $(this).attr('data-slide'));
        });
        $('.slideshow-wrapper .slick-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const $container = $(this).closest('.slideshow-wrapper');
            $container.find('.slider__nav .nav__item').removeClass('active');
            $container.find(`.slider__nav li:eq(${nextSlide}) .nav__item`).addClass('active');
        });

        $('.toggle-zoom').click(function (e) {
            e.preventDefault();
            $(this).parent().addClass('zoom-active');
            $(this).parent().find('.zoom-container').show();
            new ImageZoom($(this), $(this).parent().find('.zoom-container'));
        });
        $('.zoom-container').click(function (e) {
            e.preventDefault();
            $(this).parent().removeClass('zoom-active');
            $(this).parent().find('.img-zoom-lens').remove();
            $(this).hide();
        });
    }

    initStickyNav() {
        const $navbar = $('#sticky-nav');
        const $hero = $('.hero');
        const offset = $hero.offset();
        const sticky = offset.top + $hero.outerHeight();

        function stickyNav() {
            if (window.pageYOffset >= sticky && !$('.product-selector__form').is(':visible')) {
                $navbar.addClass('active');
            } else {
                $navbar.removeClass('active');
            }
        }

        window.onscroll = () => {
            stickyNav();
        };

        $navbar.hover(() => {
            if ($navbar.find('.dropdown').length > 0) {
                $navbar.find('.dropdown').toggleClass('open');
                $navbar.find('.image-wrapper--active').toggleClass('hidden');
            }
        });

        $('.product-selector__current').click((e) => {
            e.preventDefault();
            $navbar.removeClass('active');
            $('.header--product-selector').find('.product-selector__form').show();
        });
    }

    async render() {
        await this.fetchPost();

        if (Electro.DEBUG) {
            console.log('Product Detail: Render');
        }
        window.state = this.state;

        this.initStickyNav();
        this.reInit();
    }

    reInit() {
        const activeSKU = this.state.post.acf.skus[this.state.activeSKU];
        if (Electro.DEBUG) {
            console.log(activeSKU);
        }

        $('.loading-indicator').hide();
        // render templates
        $('.gallery-wrapper').html(productGallery(activeSKU));
        // Update section nav
        $('.nav--layouts').find('.nav-item--sku-section').remove();
        $('.nav--layouts .nav-item--general:eq(-1)').after(contentNav(activeSKU));
        // Update section layouts
        $('.container--layouts').find('.sku-section').remove();
        $('.container--layouts .content-sections--main').append(contentSections(activeSKU));

        // update individual elements
        $('.product__title').html(activeSKU.sku_name);
        $('#sticky-nav .img--active-product').css('background-image', `url(${activeSKU.gallery[0].image})`);

        this.initProductGallery();

        $('body').scrollspy('refresh');

        $('.lazy').Lazy(window.lazyOptions);
    }
}
